import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import resolveSpacing from "../../utils/spacing";
import css from "./Grid.module.css";

const resolveColumns = (columns) => {
  if (columns == null) return undefined;
  return typeof columns === "number" ? `repeat(${columns}, 1fr)` : columns;
};

const resolveRows = (rows) => {
  if (rows == null) return undefined;
  return typeof rows === "number" ? `repeat(${rows}, 1fr)` : rows;
};

const Grid = React.forwardRef(
  (
    {
      columns,
      rows,
      gap,
      columnGap,
      rowGap,
      align,
      justify,
      padding,
      as: Component = "div",
      className,
      style,
      children,
      ...rest
    },
    ref,
  ) => {
    const customProperties = Object.fromEntries(
      Object.entries({
        "--grid-columns": resolveColumns(columns),
        "--grid-rows": resolveRows(rows),
        "--grid-gap": resolveSpacing(gap),
        "--grid-column-gap": resolveSpacing(columnGap),
        "--grid-row-gap": resolveSpacing(rowGap),
        "--grid-align": align,
        "--grid-justify": justify,
        "--grid-padding": resolveSpacing(padding),
      }).filter(([, v]) => v !== undefined),
    );

    return (
      <Component
        ref={ref}
        className={clsx(css.root, className)}
        style={{ ...customProperties, ...style }}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

Grid.displayName = "Grid";

Grid.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  columnGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rowGap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.string,
  justify: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  as: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Grid;
